import React from 'react';
import { Toast } from 'react-bootstrap';
/**
 * alerts can contain a message and an id [{ message, id }]
 * @returns
 */
export default function AlertList(_ref) {
  let {
    alertClassName = '',
    alerts,
    setAlerts,
    removeAllAlerts,
    onRemoveAlert
  } = _ref;
  const onRemoveAlertInternal = id => {
    if (typeof onRemoveAlert === 'function') {
      onRemoveAlert(id);
      return;
    }
    if (removeAllAlerts) {
      setAlerts([]);
    } else {
      setAlerts(alerts.filter(alert => alert.id !== id));
    }
  };
  return alerts.map((a, i) => {
    return /*#__PURE__*/React.createElement(Toast, {
      style: {
        position: 'relative'
      },
      key: a.id,
      className: "bg-warning text-white ".concat(alertClassName),
      show: true,
      onClose: () => onRemoveAlertInternal(a.id)
    }, /*#__PURE__*/React.createElement(Toast.Header, {
      style: {
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "warning"), " ", /*#__PURE__*/React.createElement("span", {
      className: "ms-3"
    }, a.message))));
  });
}